import { apiFGTS } from '../http/httpClient'

interface EditTransactionInput {
  crefazValidation: boolean
  transactionId?: string
  phone?: string
  accountType?: string
  bank?: string
  agency?: string
  account?: string
}

export const editTransaction = async (
  input: EditTransactionInput,
): Promise<any> => {
  const { transactionId, ...formData } = input
  const response = await apiFGTS
    .put<any>(`/transaction/${transactionId}`, formData)
    .catch((error) => {
      throw error.response.data
    })
  return response.data
}
